import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { SharesproApiErrorCode } from 'enums/shared/sharesproApiErrorCode';
import i18next from 'i18next';
import { authSlice } from 'slices/modules/auth/authSlice';
import { AuthStatus } from 'slices/modules/auth/authState';
import { RootState } from 'store';
import { isSharesproFetchQueryError } from './isSharesproFetchQueryError';
import { SharesproApiResponse } from './types/sharesproApiResponse';

export const SHARESPRO_API_BASE_URL = 'https://13-api-dev.testsharespro.ru/api/';

const appFetchBaseQuery = fetchBaseQuery({
  baseUrl: process.env['REACT_APP_SHARESPRO_API_BASE_URL'],
  // baseUrl: SHARESPRO_API_BASE_URL,
});

const getApiLangId = (lang: string): number => {
  return lang.split('-')[0] === 'en' ? 2 : 1;
};

export const sharesproApi = createApi({
  keepUnusedDataFor: 0,
  reducerPath: 'sharesproApi',
  tagTypes: [
    'ChatMessages',
    'PeOrders',
    'PeOrderDetail',
    'ArticleComments',
    'Notifications',
    'ScorShowcase',
    'ScorReports',
    'ScorOrders',
    'ScorShares',
    'ScorReferral',
    'ScorSubscription',
    'ScorInvoices',
    'ScorInvoice',
    'ScorDocuments',
  ],
  baseQuery: async (args, api, extraOptions) => {
    if (args.sendToken) {
      const authState = (api.getState() as RootState).auth;
      if (authState.status === AuthStatus.LoggedIn) {
        const credentialsKey = process.env['REACT_APP_SHARESPRO_API_CREDENTIALS_HEADER_KEY'] ?? 'SID';
        args.headers = Object.assign(args.headers ?? {}, {
          [credentialsKey]: authState.sid,
        });
      }
    }

    args.headers = Object.assign(args.headers ?? {}, {
      'APP-LANGUAGE': getApiLangId(args.language ?? i18next.language),
    });

    const { language: _language, ...requestArgs } = args;
    const resp = await appFetchBaseQuery(requestArgs, api, extraOptions);
    if (
      isSharesproFetchQueryError(resp.error) &&
      (resp.error.data as SharesproApiResponse<any>).error_code ===
        SharesproApiErrorCode.SessionNotFound
    ) {
      api.dispatch(authSlice.actions.logout());
    }

    return resp;
  },
  endpoints: (builder) => ({}),
});

export default sharesproApi;
